export default "__VITE_ASSET__Cbfdvyrx__"